import { DomainProtectedConfigResponse, LandingConfig } from '@eagle/core-data-types';
import { AxiosInstance } from 'axios';
import { merge } from 'lodash';
import { DomainCustomConfig } from '../auth';
import { makeQueryablePromise, QueryablePromise } from './promise';

// config is fetched from the domain customization service and can therefore have different values per domain

export const DEFAULT_CONFIG: Partial<DomainProtectedConfigResponse> = {
  environment: 'prod',
};

export const applyDefaultConfig = (config: Partial<DomainCustomConfig>): Partial<DomainCustomConfig> => {
  return merge({}, DEFAULT_CONFIG, config);
};

const configCache = new Map<string, QueryablePromise<DomainProtectedConfigResponse>>();

export const loadConfig = (axios: AxiosInstance, domain: string): Promise<Partial<DomainProtectedConfigResponse>> => {
  const cachedConfig = configCache.get(domain);
  if (cachedConfig && !cachedConfig.isRejected()) return cachedConfig;

  const config = makeQueryablePromise(axios.get<DomainProtectedConfigResponse>('/api/protected-config', { params: { domain } })
    .then((response) => {
      const remote: DomainProtectedConfigResponse = response.data;
      return Promise.resolve({
        ...DEFAULT_CONFIG,
        ...remote,
      });
    }));

  configCache.set(domain, config);
  return config;
};

export const getConfigPortalProps = (config: Partial<DomainCustomConfig>, field: keyof LandingConfig, portal: string, defaultValue: string): string => {
  const portalConfig = config.portals?.[portal];
  if (portalConfig?.landing && portalConfig?.landing[field]) return portalConfig.landing[field] as string;
  return defaultValue;
};
